<template>
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

              <div class="modal-header">
                <slot name="header">
                  <h3>Фильтр</h3>
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                    <div class="filter-checkboxes">
                        <b-form-checkbox-group
                        
                            v-model="selectedItems"
                            :options="options"
                            class="mb-3"
                            value-field="item"
                            text-field="name"
                            disabled-field="notEnabled"
                        >
                           
                        </b-form-checkbox-group>
                    </div>
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                    <vmbutton @click="$emit('close', selectedItems)"> Сохранить </vmbutton>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
</template>

<script>
import vmbutton from '@app/components/uikit/VMButton';

export default {
    name: 'filterSearch',
    components: {
        vmbutton
    },
    data() {
        return {
            selectedItems: this.selected,
            options: [
                {   item: 'patient', name: 'По пациенту'   },
                {   item: 'cardid', name: 'По номеру карты'   },
                {   item: 'birthday', name: 'По дате рождения'   },
                {   item: 'phone', name: 'По номеру телефона'   }
            ]
        };
    },
    props: ['selected']
};
</script>


<style lang="scss" scoped>
    @import '@app/styles/modal.scss';

    ::v-deep .custom-checkbox {
        margin: 0.8rem;
    }
</style>